import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormValidatorService } from '../../../../shared/services/form-validator.service';
import { Validators } from '../../../../shared/validators';
import { CustomValidators } from '../../../../shared/custom-validators';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SendTokenService } from '../../services/send-token-service';
import { GetSellerRoleService } from '../../../../dashboard/seller/team/services/get-seller-role.service';
import { SignUpMembrService } from '../../services/signup-member-service';
import { LoginService } from '../../services/login.service';
import { ReCaptchaService } from 'angular-recaptcha3';

@Component({
  selector: 'app-sign-up-team-member',
  templateUrl: './sign-up-team-member.component.html',
  styleUrls: ['./sign-up-team-member.component.scss'],
})
export class SignUpTeamMemberComponent implements OnInit {
  roles: any;
  roleId = 2;
  token: string;
  butDisabled: boolean = true;
  signupForm: FormGroup;
  validationError: [
    {
      field: string;
      message: string;
      validation: string;
    }
  ];
  referralCode: string;
  notOnlyNumPattern = /(?!^\d+$)^.+$/g;
  textOnlyPattern =
    /^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z-_\.]*$/;
  noSpacesPattern = /^\S*$/;
  constructor(
    private rolesFetch: GetSellerRoleService,
    private login: LoginService,
    private activatedRoute: ActivatedRoute,
    public formValidator: FormValidatorService,
    private sendTokenService: SendTokenService,
    private router: Router,
    private signUpMembrService: SignUpMembrService,
    private translate: TranslateService,
    private recaptchaService: ReCaptchaService,
  ) {}

  async ngOnInit() {
    if (localStorage.getItem('language')) {
      this.translate.use(localStorage.getItem('language'));
    }
    this.initForm();
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    })
    await this.activatedRoute.params.subscribe(async (a) => {
      if (a['token']) {
        this.token = a['token'];
        this.sendTokenService.setParams({ token: a['token'] });
        const response = await this.sendTokenService.make();
        this.roles = await this.rolesFetch.make();
        if (response.isValid) {
          this.roleId = this.roles.id;
          this.signupForm.controls['firstName'].setValue(
            response.request.firstName
          );
          this.signupForm.controls['lastName'].setValue(
            response.request.lastName
          );
          this.signupForm.controls['email'].setValue(response.request.email);
          this.signupForm.controls['roleId'].setValue(response.request.roleId);
        } else {
          this.router.navigateByUrl('/signup');
        }
      }
    });
  }

  initForm() {
    this.signupForm = this.formValidator.createForm([
      {
        fieldName: 'firstName',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: Validators.minLength(2),
            message: '',
          },
          {
            validatorFn: CustomValidators.customPattern(this.notOnlyNumPattern),
            message: '',
          },
          {
            validatorFn: Validators.maxLength(20),
            message: '',
          },
          {
            validatorFn: CustomValidators.customPattern(this.textOnlyPattern),
            message: '',
          },
          {
            validatorFn: CustomValidators.customPattern(this.noSpacesPattern),
            message: '',
          },
        ],
      },
      {
        fieldName: 'lastName',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: Validators.minLength(2),
            message: '',
          },
          {
            validatorFn: CustomValidators.customPattern(this.notOnlyNumPattern),
            message: '',
          },
          {
            validatorFn: Validators.maxLength(20),
            message: '',
          },
          {
            validatorFn: CustomValidators.customPattern(this.textOnlyPattern),
            message: '',
          },
          {
            validatorFn: CustomValidators.customPattern(this.noSpacesPattern),
            message: '',
          },
        ],
      },
      {
        fieldName: 'mobile',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: ''
          },
          {
            validatorFn: CustomValidators.requiredNumber,
            message: ""
          },
          {
            validatorFn: Validators.minLength(11),
            message: ""
          },
          {
            validatorFn: Validators.maxLength(11),
            message: ""
          },
        ],
      },
      {
        fieldName: 'password',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: Validators.minLength(8),
            message: '',
          },
          {
            validatorFn: CustomValidators.complexPassword('s'),
            message: ""
          },
        ],
      },
      {
        fieldName: 'email',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: Validators.email,
            message: '',
          },
        ],
      },
      {
        fieldName: 'roleId',
        defaultValue: this.roleId,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
    ]);

    if (sessionStorage.getItem('referralCode')) {
      this.signupForm.controls['referral_code'].setValue(
        sessionStorage.getItem('referralCode')
      );
    } else {
      this.referralCode = '';
    }
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        firstName: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'First name',
            fieldAr: 'الإسم الأول'
          }),
          customPattern: this.translate.instant('FormValidation.TextOnly', {
            field: 'First name',
            fieldAr: 'الإسم الأول'
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'First name',
            fieldAr: 'الإسم الأول',
            value: 2
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: 'First name',
            fieldAr: 'الإسم الأول',
            value: 20
          }),
        },
        lastName: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير'
          }),
          customPattern: this.translate.instant('FormValidation.TextOnly', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير'
          }),
          minLength: this.translate.instant('FormValidation.MinLength', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير',
            value: 2
          }),
          maxLength: this.translate.instant('FormValidation.MaxLength', {
            field: 'Last name',
            fieldAr: 'الإسم الاخير',
            value: 20
          }),
        },
        mobile: {
          required: this.translate.instant("FormValidation.Empty", {
            field: "Phone",
            fieldAr: "رقم الهاتف"
          }),
          minlength: this.translate.instant('FormValidation.MinLength', {
            field: 'Phone',
            fieldAr: 'رقم الهاتف',
            value: 11
          }),
          maxlength: this.translate.instant('FormValidation.MaxLength', {
            field: 'Phone',
            fieldAr: 'رقم الهاتف',
            value: 11
          }),
          requiredNumber: this.translate.instant('FormValidation.RequiredNumber')
        },
        password: {
          required: this.translate.instant("FormValidation.Empty", {
            field: "Password",
            fieldAr: "كلمة المرور"
          }),
          minLength: this.translate.instant("FormValidation.MinLength", {
            field: "password",
            fieldAr: "كلمة المرور",
            value:8
          }),
          complexPassword:this.translate.instant("FormValidation.complexPassword", {
            field: "password",
            fieldAr: "كلمة المرور",
          }),
        },
        email: {
          required: this.translate.instant("FormValidation.Empty", {
            field: "Email",
            fieldAr: "البريد الاكتروني"
          }),
          email: this.translate.instant("FormValidation.ValidEmail", {
            field: "email",
            fieldAr: "البريد الاكتروني"
          }),
        },
        roleId: {
          required: this.translate.instant("FormValidation.Empty", {
            field: "Role",
            fieldAr: "الدور"
          }),
        },
      }
    });
  }

  async onSignup() {
    try {
      const recaptchaToken = await this.recaptchaService.execute({
        action: 'teamMemberSignup',
      });
      const recaptchaTokenLogin = await this.recaptchaService.execute({
        action: 'login',
      });
      this.signUpMembrService.setParams({
        token: this.token,
        ...this.signupForm.value,
        recaptchaToken
      });

      const result = await this.signUpMembrService.make();
      if (result.token) {
        this.login.setParams({
          email: this.signupForm.value.email,
          password: this.signupForm.value.password,
          recaptchaToken: recaptchaTokenLogin,
        });
        await this.login.make();
      }
    } catch (errors) {
      this.validationError = errors.validationErrors.error;
      for (const e of this.validationError) {
        this.formValidator.addError(e.field, 'invalid', e.message);
        this.signupForm.controls[e.field].setErrors({ invalid: e.message });
        this.formValidator.ShowErrors();
      }
    }
  }
}
